module.exports = __webpack_public_path__ + "img/hongly-logo2.d40bab9d.png";